const getIssuerDisplayName = (state, issuer, defaultResult) => {

    if(!defaultResult) defaultResult = '';
    if(!issuer?.localizedTerms) return defaultResult;
    
    let displayName = issuer.localizedTerms?.find(l => l.languageId === state.account.language.languageId)?.displayName;
    if(!displayName)
        return issuer?.code 
            ? issuer.code 
            : defaultResult;

    return displayName;
}

export const dataManager = { getIssuerDisplayName }